import { BaseNode } from './BaseNode';

export function RetryNode({ data }: { data: { label: string } }) {
  return <BaseNode type="retry" label={data.label} hasSource={false} lines={[{ text: 'max 5 · exponential' }]} />;
}
